/** See dq-seal-client/src/utils/toBrandingLogoSrc.js — kept in sync. */
export function toBrandingLogoSrc(logoUrl) {
    if (!logoUrl || typeof logoUrl !== 'string') return null;

    const apiBase = (process.env.REACT_APP_MYDQ_API || '').replace(/\/v1\/?$/, '');

    try {
        const u = new URL(logoUrl);
        const isLocalDisk = u.hostname === 'localhost' || u.hostname === '127.0.0.1';
        // Absolute URL from object storage (GCS) / any real host → use as-is.
        if (!isLocalDisk) return logoUrl;
        return apiBase ? `${apiBase}${u.pathname}` : logoUrl;
    } catch {
        if (apiBase && logoUrl.startsWith('/')) return `${apiBase}${logoUrl}`;
        return logoUrl;
    }
}

export default toBrandingLogoSrc;
